import React from "react";

function Navbar () {
    return (
        <nav className="navbar bg-body-tertiary">
            <div style={{justifyContent : "center"}} className="container-fluid">
                <span className="navbar-text">
                    <h1>Bank of Flatiron</h1>
                </span>
            </div>
        </nav>
    )
}

export default Navbar